export default __webpack_public_path__ + "static/media/relative-faux-book-pro.d12e67dc.woff";